/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import FormButton from '../ui/button/FormButton';
import {useDispatch, useSelector} from 'react-redux';
import {API} from '../../pages/backend';
import axios from 'axios';
import {Box, Typography} from '@mui/material';
import {toast} from 'react-toastify';
import {MdErrorOutline} from 'react-icons/md';
import {TbFaceIdError} from 'react-icons/tb';
import {showModal} from '../../store/reducers/modal';
import domtoimage from 'dom-to-image';
import ResponsiveFormButton from '../ui/button/ResponsiveFormButton';
import styles from './billcard.module.scss';
import Spinner from '../ui/Spinner';
import {Link, useNavigate} from 'react-router-dom';
import Invoicedownload from '../invoice/Invoicedownload';
import {setTransactionDetails} from '../../store/reducers/transactionDetails';
import {setBills} from '../../store/reducers/bills';
import {PDFDownloadLink} from '@react-pdf/renderer';
import DownloadToPdf from '../downloadReceipt/DownloadToPdf';

const BillCard = ({url, examName}) => {
  console.log(url);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const details = useSelector(
    (state) => state?.transactionDetails?.data?.transactionDetails
  );

  // const details = useSelector((state) => state.transactionDetails.data.transactionDetails)
  // console.log(details);
  const [loading, setLoading] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [loadingState, setLoadingState] = useState({});
  const user = useSelector((state) => state.user.data.details);
  const token = useSelector((state) => state?.user?.data?.token);
  // console.log(token);
  const [billDetails, setBillDetails] = useState([]);
  console.log(billDetails);

  const [getPinDetails, setPinDetails] = useState();
  
  // Solution 2: Add a Set to track which bills have already generated receipts
  const [generatedBills, setGeneratedBills] = useState(new Set());

  const getAllBills = async () => {
    try {
      const res = await axios.get(url, {
        headers: {Authorization: `Bearer ${token}`},
      });
      if (res?.status === 200) {
        // console.log(res?.data?.details?.rows);
        // console.log(res?.data?.data?.details?.rows);
        setBillDetails(res?.data?.data?.details?.rows);
        const bills = res?.data?.data?.details?.rows;
        console.log(bills);
        dispatch(setBills(bills));
        
        // Optional: Check localStorage for previously generated bills
        const storedGeneratedBills = localStorage.getItem('generatedBills');
        if (storedGeneratedBills) {
          setGeneratedBills(new Set(JSON.parse(storedGeneratedBills)));
        }
      }
    } catch (error) {
      toast.error('Cannot generate bill cards at the moment. Try again later.');
      // console.log(error);
    }
  };

  const formatDate = (dateArg) => {
    let time = 'loading...';
    let date = 'loading...';
    if (dateArg) {
      time = new Date(dateArg).toLocaleTimeString('en-GB', {hour12: true});
      date = new Date(dateArg).toDateString();
    }

    let datetime = time + ' ' + date;
    return {time, date, datetime};
  };



  // links
  const link = examName ? "Screening" : ""

  // Solution 1 & 2: Combined generate function with duplicate prevention
  const generatePin = async (billNumber) => {
    // Solution 2: Prevent duplicate generation
    if (generatedBills.has(billNumber)) {
      toast.warning('Receipt already generated for this bill. Please download the existing receipt.');
      return;
    }
    
    // Check if already loading
    if (loadingState[billNumber]) {
      toast.info('Receipt generation is in progress...');
      return;
    }
    
    // Find the specific bill with the matching billNumber
    setLoadingState((prev) => ({...prev, [billNumber]: true}));
    const bill = billDetails.find((bill) => bill.billNumber === billNumber);

    const payersDetails = {
      billNumber: bill.billNumber,
      payerId: bill.payerId,
      assessmentCode: bill.assessmentCode,
      payerInfos: bill.payerInfos,
    };

    console.log(payersDetails);
    try {
      const res = await axios.post(
        `${API}/innotelligent/generate/individual_code`,
        payersDetails,
        {
          headers: {Authorization: `Bearer ${token}`},
        }
      );

      console.log(res);
      if (res?.status === 200 || res?.status === 200) {
        const candidateDetails = res.data.data.candidateLoginDetails;

        // Generate candidate details content
        const candidateContent = candidateDetails.map((candidate, index) => (
          <div key={index} style={{width: '100%'}}>
            <div
              style={{
                display: 'flex',
                height: 'auto',
                gap: window.innerWidth >= 500 ? '90px' : '40px',
              }}>
              <Typography>{candidate.fullName}</Typography>
              <Typography>{candidate.examinationNumber}</Typography>
              <Typography>{candidate.pin}</Typography>
            </div>
          </div>
        ));
        console.log(candidateDetails);
        console.log(payersDetails);
        setPinDetails(payersDetails);
        
        // Solution 2: Mark this bill as generated
        setGeneratedBills(prev => {
          const newSet = new Set(prev);
          newSet.add(billNumber);
          // Store in localStorage for persistence
          localStorage.setItem('generatedBills', JSON.stringify(Array.from(newSet)));
          return newSet;
        });

        dispatch(
          showModal({
            content: (
              <div>
                <div>
                  <div
                    id='modalContent'
                    style={{
                      backgroundColor: 'white',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      height: '550px',
                      maxHeight: '400px',
                      overflowY: 'auto',
                      overflowX: 'auto',
                      position: 'relative',
                    }}>
                    <Typography fontWeight={'bold'} variant='h6'>
                      Receipt generated successfully
                    </Typography>
                    {/* the background image */}
                    <div className={styles.receipt_image}></div>
                    <div
                      style={{
                        display: 'flex',
                        gap: window.innerWidth >= 500 ? '90px' : '40px',
                        marginTop: '20px',
                      }}>
                      <Typography fontWeight={'bold'}>Full Name:</Typography>
                      <Typography fontWeight={'bold'}>
                        Examination Number:
                      </Typography>
                      <Typography fontWeight={'bold'}>Pin:</Typography>
                    </div>
                    <div style={{gap: '10px'}}>{candidateContent}</div>
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: 'auto',
                    gap: window.innerWidth >= 500 ? '100px' : '10px',
                  }}>
                  <div>
                    <PDFDownloadLink
                      document={<DownloadToPdf data={candidateDetails} />}
                      fileName='receipt.pdf'
                      style={{
                        backgroundColor: '#34A56F',
                        color: 'white',
                        padding: '15px 20px',
                        textDecoration: 'none',
                        borderRadius: '5px',
                        display: 'inline-block',
                        textAlign: 'center',
                      }}>
                      {({blob, url, loading, error}) =>
                        loading ? 'Generating receipt...' : 'Download Receipt'
                      }
                    </PDFDownloadLink>
                  </div>

                  <div>
                    <ResponsiveFormButton
                      label={`${examName} Exam`}
                      onClick={() => {
                        const newWindow = document.createElement('a');
                        newWindow.href =
                          'https://screeningtest.examsboard.lagosstate.gov.ng/';
                        newWindow.target = '_blank';
                        newWindow.rel = 'noopener noreferrer';
                        newWindow.click();
                      }}
                    />
                  </div>
                </div>
              </div>
            ),
          })
        );
      }
    } catch (error) {
      console.error('Error generating pin:', error);
      toast.error('Failed to generate receipt. Please try again.');
    } finally {
      setLoadingState((prev) => ({...prev, [billNumber]: false}));
    }
  };

  // Remove the generateManualPin function since we're using just one function now
  // The old generateManualPin function is removed to prevent confusion

  useEffect(() => {
    getAllBills();
  }, []);

  return (
    <div>
      {billDetails ? (
        billDetails?.length === 0 ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              paddingTop: '50px',
              gap: '40px',
            }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '5px',
              }}>
              <MdErrorOutline size={'25px'} />
              <Typography align='center' fontSize={'19px'} fontWeight={500}>
                {' '}
                You have not raised a bill/invoice on this platform yet.{' '}
              </Typography>
            </div>

            <Typography align='center' fontSize={'17px'} fontWeight={600}>
              {' '}
              Click on the User Details tab to generate an invoice.{' '}
            </Typography>
          </div>
        ) : (
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
            }}>
            {billDetails?.map((item, i) => (
              <div
                key={item.billNumber || i}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: window.innerWidth >= 320 ? '30px 0px' : '30px',
                  width: window.innerWidth >= 320 ? '400px' : '150px',
                }}>
                <div
                  style={{
                    border: '1px solid #34A56F',
                    borderRadius: '10px',
                    width: window.innerWidth >= 720 ? '650%' : '80%',
                    height: window.innerWidth >= 500 ? '450px' : '570px',
                    display: 'flex',
                    flexDirection: 'column',
                    padding:
                      window.innerWidth >= 320
                        ? '20px 20px 20px 20px'
                        : '200px, 200px',
                    gap: '25px',
                    backgroundColor: '#f2fcf8',
                  }}>
                  <div
                    style={{
                      backgroundColor: '#f2fcf8',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '20px',
                      padding: '20px',
                    }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        fontSize: '18px',
                        fontWeight: '600',
                      }}>
                      Bill Number: {item?.billNumber}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        fontSize: '18px',
                        fontWeight: '600',
                        textTransform: 'capitalize',
                      }}>
                      Payer Name: {item?.customerName}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        fontSize: '18px',
                        fontWeight: '600',
                      }}>
                      Amount Paid: {item?.amountGenerated}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        fontSize: '18px',
                        fontWeight: '600',
                      }}>
                      No of Candidates: {item?.quantity}
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        fontSize: '18px',
                        fontWeight: '600',
                      }}>
                      Time: {formatDate(item?.createdAt).time}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        fontSize: '18px',
                        fontWeight: '600',
                      }}>
                      Date: {formatDate(item?.createdAt).date}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        gap: '10px',
                        alignItems: 'center',
                      }}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          fontSize: '18px',
                          fontWeight: '600',
                          gap: '10px',
                        }}>
                        Payment Status:{' '}
                      </div>
                      {item.status === 'Awaiting Confirmation' ? (
                        <p
                          style={{
                            padding: '5px 5px',
                            backgroundColor: '#EE9513',
                            fontSize: '17px',
                            color: '#ffffff',
                            borderRadius: '4px',
                          }}>
                          {'Pending'}
                        </p>
                      ) : item.status === 'Paid' || item.status === 'paid' ? (
                        <p
                          style={{
                            padding: '5px 5px',
                            backgroundColor: '#34a56f',
                            fontSize: '17px',
                            color: '#ffffff',
                            borderRadius: '4px',
                          }}>
                          {item.status.charAt(0).toUpperCase() +
                            item.status.slice(1)}
                        </p>
                      ) : (
                        <p
                          style={{
                            padding: '5px 5px',
                            backgroundColor: '#34a56f',
                            fontSize: '17px',
                            color: '#ffffff',
                            borderRadius: '4px',
                          }}>
                          {'Pending'}
                        </p>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexWrap: window.innerWidth <= 500 ? 'wrap' : '',
                      justifyContent: 'center',
                      alignItems: 'center',
                      margin: 'auto',
                      gap: window.innerWidth >= 500 ? '30px' : '10px',
                    }}>
                    <div>
                      <ResponsiveFormButton
                        type='button'
                        label='Download Invoice'
                        onClick={() => {
                          window.scrollTo(5, 50);
                          navigate(`/invoice/download/${item.id}`);
                        }}
                      />
                    </div>
                    <div>
                      {/* Solution 1: Normalized status check - case insensitive */}
                      {item?.status?.toLowerCase() === 'paid' ? (
                        <ResponsiveFormButton
                          type='button'
                          label={
                            loadingState[item.billNumber] ? (
                              <Spinner width='5%' />
                            ) : generatedBills.has(item.billNumber) ? (
                              'Receipt Already Generated'
                            ) : (
                              'Generate Receipt'
                            )
                          }
                          disabled={generatedBills.has(item.billNumber)}
                          onClick={() => generatePin(item.billNumber)}
                        />
                      ) : (
                        <ResponsiveFormButton
                          type='button'
                          disabled={true}
                          label={
                            loadingState[item.billNumber] ? (
                              <Spinner width='5%' />
                            ) : (
                              'Generate Receipt'
                            )
                          }
                        />
                      )}
                    </div>
                  </div>
                  {/* Optional: Show message if receipt already generated */}
                  {generatedBills.has(item.billNumber) && item?.status?.toLowerCase() === 'paid' && (
                    <div style={{ textAlign: 'center', marginTop: '-15px' }}>
                      <Typography style={{ color: '#34A56F', fontSize: '14px' }}>
                        ✓ Receipt has been generated for this bill
                      </Typography>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </Box>
        )
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: '50px',
            gap: '5px',
          }}>h
          <TbFaceIdError size={'25px'} />
          <Typography align='center' fontSize={'19px'} fontWeight={500}>
            {' '}
            Can't seem to get your bill/invoice details at the moment. Can you
            try again later?{' '}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default BillCard;